import * as React from 'react';
import { CardsManagerCallbacks } from '../CardsManager/CardsManager';
import { Switch, Route } from 'react-router-dom';
import Collection from '../CollectionCard/Collection/Collection';
import AddCollection from './AddCollection/AddCollection';
import './Collections.css';

interface Props {
	callbacks: CardsManagerCallbacks;
}

const Collections: React.FC<Props> = ({ callbacks }) => {
	return <div className="collection">
		<div className="collection__wrapper">
			<Switch>
				<Route path="/add">
					<AddCollection callbacks={callbacks}/>
				</Route>

				<Route path="/:id">
					<Collection callbacks={callbacks} />
				</Route>
			</Switch>
		</div>
	</div>;
};

export default Collections;
